import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';
import { RTKQueryTag } from 'src/common/constants';
import { is404Error } from 'src/common/helpers/error-handlers';
import { ScoreboardUser } from 'src/common/interfaces/scoreboard';

import { Module, ModuleScoreboardQueryParams, InviteModuleTeammatesBody } from './module.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getModule: builder.query<ApiResponse<Module>, string>({
      query: (moduleURL) => ({
        method: 'GET',
        url: `modules/data?moduleURL=${moduleURL}`,
      }),
      providesTags: [RTKQueryTag.Module],
      onQueryStarted: async (arg, { queryFulfilled }) => {
        try {
          await queryFulfilled;
        } catch (error) {
          if (is404Error(error)) {
            window.location.replace('r/404');
          }
        }
      },
    }),
    getModuleScoreboard: builder.query<ScoreboardUser[] | undefined, ModuleScoreboardQueryParams>({
      query: ({ roomCodes, limit }: ModuleScoreboardQueryParams) => ({
        method: 'GET',
        url: `modules/scoreboard`,
        params: {
          roomCodes,
          limit,
        },
      }),
      providesTags: [RTKQueryTag.ModuleScoreboard],
      transformResponse: (response: ApiResponse<ScoreboardUser[]>) => response.data,
    }),
    inviteModuleTeammates: builder.mutation<
      ApiResponse<{
        data: null;
      }>,
      InviteModuleTeammatesBody
    >({
      query: (body) => ({ method: 'POST', url: 'modules/invite-teammates', body }),
    }),
  }),
});

export const { useGetModuleQuery, useGetModuleScoreboardQuery, useInviteModuleTeammatesMutation } = extendedApiSlice;
